import React, { useEffect, useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import Appx from "./east_cal";
import Appx1 from "./wbpcb_salt_lake";
import Appx2 from "./city_center";
import moment from "moment";

export default function App() {
    const [AQIInfo, setAQIInfo] = useState<any>([]);
    const [NoiseInfo, setNoiseInfo] = useState<any>({ laeqt: null });
    // console.log("noi :: ", NoiseInfo)

    const [AQIInfo1, setAQIInfo1] = useState<any>([]);
    const [NoiseInfo1, setNoiseInfo1] = useState<any>({ laeqt: null });
    // console.log("noi :: ", NoiseInfo1)

    const [AQIInfo2, setAQIInfo2] = useState<any>([]);
    const [NoiseInfo2, setNoiseInfo2] = useState<any>({ laeqt: null });
    // console.log("noi :: ", NoiseInfo2)

    const [AQIColor, setAPIColor] = useState({
        color: "#2BCD11",
        type: "Good",
    });
    const [AQIColor1, setAPIColor1] = useState({
        color: "#2BCD11",
        type: "Good",
    });
    const [AQIColor2, setAPIColor2] = useState({
        color: "#2BCD11",
        type: "Good",
    });
    
    const hours = new Date().getHours();
    const [NoiseData, setNoiseColor] = useState<any>({ laeqt: null , color: '#00af50'});
    const [NoiseData1, setNoiseColor1] = useState<any>({ laeqt: null , color: '#00af50'});
    const [NoiseData2, setNoiseColor2] = useState<any>({ laeqt: null , color: '#00af50'});

    const [isDayTime, setIsDayTime] = useState(hours > 6 && hours < 20);
    const [time, setTime] = useState<string>('');
 
    useEffect(() => {
        // Update the time every 5 second
        const intervalId = setInterval(() => {
          setIsDayTime(hours > 6 && hours < 22);
          setTime(moment().format("hh:mm A"));
        }, 5000);
    
        // Clean up the interval on component unmount
        return () => clearInterval(intervalId);
      }, []);
    

    const getNoiseColorHandler = ({ laeqt } : {laeqt: number}) => {
        const limit = isDayTime ? 65 : 55;
        console.log("limit :: ", limit , laeqt);
        // console.log('isNOi C: ', NoiseInfo, isDayTime);
        // console.log("ec : ",limit, laeqt, 65 < 66.71, limit < NoiseInfo?.laeqt )
        if (limit < laeqt) {
         setNoiseColor({ laeqt: laeqt, color: '#FF0000' });
        } else {
         setNoiseColor({ laeqt: laeqt, color: '#00af50' });
        }
    }

    const getNoiseColorHandler1 = ({ laeqt } : {laeqt: number}) => {
        const limit = isDayTime ? 65 : 55;
        console.log("limit1 :: ", limit , laeqt);
        // console.log('isNOi C: ', NoiseInfo, isDayTime);
        // console.log("ec : ",limit, laeqt, 65 < 66.71, limit < NoiseInfo?.laeqt )
        if (limit < laeqt) {
         setNoiseColor1({ laeqt: laeqt, color: '#FF0000' });
        } else {
         setNoiseColor1({ laeqt: laeqt, color: '#00af50' });
        }
    }

    
    const getNoiseColorHandler2 = ({ laeqt } : {laeqt: number}) => {
        const limit = isDayTime ? 65 : 55;
        console.log("limit2 :: ", limit , laeqt);
        // console.log('isNOi C: ', NoiseInfo, isDayTime);
        // console.log("ec : ",limit, laeqt, 65 < 66.71, limit < NoiseInfo?.laeqt )
        if (limit < laeqt) {
         setNoiseColor2({ laeqt: laeqt, color: '#FF0000' });
        } else {
         setNoiseColor2({ laeqt: laeqt, color: '#00af50' });
        }
    }

    
    
    

    const getColorCodeHandler = ({ aqi }: { aqi: number }) => {
        // console.log("INSIDE FUNCTION",aqi);
        if (aqi && aqi <= 50) {
            setAPIColor({ color: "#2BCD11", type: "Good" });
        }
        if (aqi >= 51 && aqi <= 100) {
            setAPIColor({ color: "#AEF19D", type: "Satisfactory" });
        }
        if (aqi >= 101 && aqi <= 200) {
            setAPIColor({ color: "#FFF850", type: "Moderate" });
        }
        if (aqi >= 201 && aqi <= 300) {
            setAPIColor({ color: "#FAAF1E", type: "Poor" });
        }
        if (aqi >= 301 && aqi <= 400) {
            setAPIColor({ color: "#F45656", type: "Severe" });
        }
        if (aqi >= 401 && aqi <= 500) {
            setAPIColor({ color: "#C20000", type: "Severe" });
        }
    };

    const getColorCodeHandler1 = ({ aqi }: { aqi: number }) => {
        // console.log("INSIDE FUNCTION",aqi);
        if (aqi && aqi <= 50) {
            setAPIColor1({ color: "#2BCD11", type: "Good" });
        }
        if (aqi >= 51 && aqi <= 100) {
            setAPIColor1({ color: "#AEF19D", type: "Satisfactory" });
        }
        if (aqi >= 101 && aqi <= 200) {
            setAPIColor1({ color: "#FFF850", type: "Moderate" });
        }
        if (aqi >= 201 && aqi <= 300) {
            setAPIColor1({ color: "#FAAF1E", type: "Poor" });
        }
        if (aqi >= 301 && aqi <= 400) {
            setAPIColor1({ color: "#F45656", type: "Severe" });
        }
        if (aqi >= 401 && aqi <= 500) {
            setAPIColor1({ color: "#C20000", type: "Severe" });
        }
    };

    const getColorCodeHandler2 = ({ aqi }: { aqi: number }) => {
        // console.log("INSIDE FUNCTION",aqi);
        if (aqi && aqi <= 50) {
            setAPIColor2({ color: "#2BCD11", type: "Good" });
        }
        if (aqi >= 51 && aqi <= 100) {
            setAPIColor2({ color: "#AEF19D", type: "Satisfactory" });
        }
        if (aqi >= 101 && aqi <= 200) {
            setAPIColor2({ color: "#FFF850", type: "Moderate" });
        }
        if (aqi >= 201 && aqi <= 300) {
            setAPIColor2({ color: "#FAAF1E", type: "Poor" });
        }
        if (aqi >= 301 && aqi <= 400) {
            setAPIColor2({ color: "#F45656", type: "Severe" });
        }
        if (aqi >= 401 && aqi <= 500) {
            setAPIColor2({ color: "#C20000", type: "Severe" });
        }
    };

    const GetInformationHandler = async ({ url, currentDate }: { url: string, currentDate: string }) => {
        try {
            // Fetch AQI data
            const aqmsResponse = await fetch(
                `https://aqmsdata.wbpcb.gov.in:1443/v1.0/sens/real/get_24h_avg?dev_id=${aqmsDevId}&date_hour=${currentDate}`
            );
            const aqmsResult = await aqmsResponse.json();
            if (aqmsResult?.data) {
                setAQIInfo(aqmsResult?.data);
                getColorCodeHandler({ aqi: aqmsResult?.data[0]?.AQI });
                // console.log("AQI data API:", aqmsResult?.data);
            }
    
            // Fetch Noise data
            const anmsResponse = await fetch(`https://monster1.distronix.in:2443/anms/sens/get_latest_data_p10?dev_id=${anmsDevId}`);
            const anmsResult = await anmsResponse.json();
            if (anmsResult?.data) {
                setNoiseInfo(anmsResult?.data);
                getNoiseColorHandler({laeqt : anmsResult?.data?.laeqt})
                // console.log("Noise data API C:", anmsResult?.data?.laeqt);
            }
        } catch (error) {
            console.log(error);
        }
    };


    
    
    useEffect(() => {
      const currentDate = moment().format("YYYY-MM-DD");
      const fetchData = () => {
        GetInformationHandler({ url: window.location.href, currentDate });
      };
      fetchData();
    
      const intervalId = setInterval(fetchData, 10 * 60 * 1000); // 10 minutes in milliseconds
      return () => clearInterval(intervalId);
    }, []);
    
    // Define the device IDs for AQMS and ANMS For East Calcutta
    const aqmsDevId = "a146474f679e2ccd67bd0d0ebd497cee";
    const anmsDevId = "212b3bcbb2403d6d7e37b966df4c940a";


    // City Center 1 Park
    const GetInformationHandler2 = async ({ url, currentDate }: { url: string, currentDate: string }) => {
        try {
            // Fetch AQI data
            const aqmsResponse2 = await fetch(
                `https://aqmsdata.wbpcb.gov.in:1443/v1.0/sens/real/get_24h_avg?dev_id=${aqmsDevId2}&date_hour=${currentDate}`
            );
            const aqmsResult2 = await aqmsResponse2.json();
            if (aqmsResult2?.data) {
                setAQIInfo2(aqmsResult2?.data);
                getColorCodeHandler2({ aqi: aqmsResult2?.data[0]?.AQI });
                // console.log("AQI data API:", aqmsResult2?.data);
            }
    
            // Fetch Noise data
            const anmsResponse2 = await fetch(`https://monster1.distronix.in:2443/anms/sens/get_latest_data_p10?dev_id=${anmsDevId2}`);
            const anmsResult2 = await anmsResponse2.json();
            if (anmsResult2?.data) {
                setNoiseInfo2(anmsResult2?.data);
                getNoiseColorHandler2({laeqt: anmsResult2?.data?.laeqt })
                // console.log("Noise data API:", anmsResult2?.data?.laeqt);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
      const currentDate = moment().format("YYYY-MM-DD");
      const fetchData = () => {
        GetInformationHandler2({ url: window.location.href, currentDate });
      };
      fetchData();
    
      const intervalId2 = setInterval(fetchData, 10 * 60 * 1000); // 10 minutes in milliseconds
      return () => clearInterval(intervalId2);
    }, []);
    
    // Define the device IDs for AQMS and ANMS For City Centre 1 Park
    const aqmsDevId2 = "21082aaf237dd40340d12b601d01a238";
    const anmsDevId2 = "0f2c5b8978c9d3d0a52b601a436bf360";



    // WBPCB Salt Lake
    const GetInformationHandler1 = async ({ url, currentDate }: { url: string, currentDate: string }) => {
        try {
            // Fetch AQI data
            const aqmsResponse1 = await fetch(
                `https://aqmsdata.wbpcb.gov.in:1443/v1.0/sens/real/get_24h_avg?dev_id=${aqmsDevId1}&date_hour=${currentDate}`
            );
            const aqmsResult1 = await aqmsResponse1.json();
            if (aqmsResult1?.data) {
                setAQIInfo1(aqmsResult1?.data);
                getColorCodeHandler1({ aqi: aqmsResult1?.data[0]?.AQI });
                // console.log("AQI data API:", aqmsResult1?.data);
            }
    
            // Fetch Noise data
            const anmsResponse1 = await fetch(`https://monster1.distronix.in:2443/anms/sens/get_latest_data_p10?dev_id=${anmsDevId1}`);
            const anmsResult1 = await anmsResponse1.json();
            if (anmsResult1?.data) {
                setNoiseInfo1(anmsResult1.data);
                getNoiseColorHandler1({laeqt: anmsResult1?.data?.laeqt })
                // console.log("Noise data API:", anmsResult1?.data?.laeqt);
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
      const currentDate = moment().format("YYYY-MM-DD");
      const fetchData = () => {
        GetInformationHandler1({ url: window.location.href, currentDate });
      };
      fetchData();
    
      const intervalId1 = setInterval(fetchData, 10 * 60 * 1000); // 10 minutes in milliseconds
      return () => clearInterval(intervalId1);
    }, []);
    
     // Define the device IDs for AQMS and ANMS For WBPCB Office Saltlake
    //  const aqmsDevId1 = "a7b26005d1526394871e2453e8ed1df7";
     const aqmsDevId1 = "9277928"; // AQMS dev_id changed
     const anmsDevId1 = "bb0b0078854d9c9ada04aa8befce1579";
     
    // console.log("ch :: ", NoiseInfo1);
    // return (
    // <Appx AQIInfo={AQIInfo} NoiseInfo={NoiseInfo} AQIColor={AQIColor}/>
    // );

    return (
        <>
            <Swiper
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}
                loop={true}
                pagination={false}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper w-[1100px] h-[320px]"
            >
               <SwiperSlide >
                    {/* WBPCB */}
                    <Appx1 AQIInfo={AQIInfo1} NoiseInfo={NoiseInfo1} AQIColor={AQIColor1} NoiseData={NoiseData1} />
                </SwiperSlide>
                <SwiperSlide>
                    {/* City */}
                    <Appx2 AQIInfo={AQIInfo2} NoiseInfo={NoiseInfo2} AQIColor={AQIColor2} NoiseData={NoiseData2} />
                </SwiperSlide>
                <SwiperSlide>
                    {/* East */}
                    <Appx AQIInfo={AQIInfo} NoiseInfo={NoiseInfo} AQIColor={AQIColor} NoiseData={NoiseData} />
                </SwiperSlide> 
                {/* <SwiperSlide> */}
                    {/* East */}
                    {/* <Appx2 AQIInfo={AQIInfo} NoiseInfo={NoiseInfo} AQIColor={AQIColor}/> */}
                {/* </SwiperSlide> */}
            </Swiper>
        </>
    );

    
}

